import { render, staticRenderFns } from "./AddDeveloperTitleModal.vue?vue&type=template&id=2b72b6ab"
import script from "./AddDeveloperTitleModal.vue?vue&type=script&lang=js"
export * from "./AddDeveloperTitleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports